import { ListItem, ListItemText } from "@mui/material";
import { useTranslation } from "react-i18next";
import { returnCategoryTranslation } from "./Functions/returnCategoryTranslation";
import ColorDisplayAndPicker from "../../../../components/common/ColorDisplayAndPicker";

export default function SummaryLine({
	category,
	value,
	isPercent,
	groupValue,
	color,
}) {
	const { t } = useTranslation();
	const displayValue = isPercent ? (value * 100) / groupValue : value;
	const userCurrency = localStorage.getItem("userCurrency");
	return (
		<>
			<ListItem key={category} sx={{ pl: 3, pt: 0, pb: 0 }}>
				<ColorDisplayAndPicker color={color} isEditable={false} />
				<ListItemText
					primary={returnCategoryTranslation(t, category)}
					sx={{ mb: 0 }}
				/>
				<ListItemText
					sx={{ textAlign: "right" }}
					primary={`${displayValue.toFixed(2).toLocaleString()} ${isPercent ? "%" : userCurrency}`}
				/>
			</ListItem>
		</>
	);
}
